import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui, rydeColors } from "@ryde/theme";

export const MapToolboxWrapperStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "map-toolbox-wrapper",
})`
  width: 100%;
  padding-top: 5px;
  padding-bottom: 2px;
  padding-inline-end: 4px;
  padding-inline-start: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  line-height: 1.2;

  .MuiFormControlLabel-root {
    margin-inline: 0;
    gap: 4px;
    .MuiFormControlLabel-label {
      font-size: 12px;
    }
  }

  .generate-points-button {
    min-height: 26px;
    padding-block: 2px;
    padding-inline: 6px;
    font-size: 11px;
    text-transform: none;
    border-color: ${greyMui._300};
    color: ${greyMui._900};
    &:hover {
      border-color: ${greyMui._500};
      color: ${greyMui._800};
    }
  }

  .map-toolbox-counter-input {
    width: 52px;
    height: 26px;
    padding-block: 2px;
    padding-inline: 3px;
    & .MuiOutlinedInput-root {
      font-size: 11px;
    }
    & .MuiInputBase-input {
      font-size: 11px;
      line-height: 1.2;
      padding-block: 2px;
      padding-inline: 4px;
      height: 18px;
      text-align: center;
    }
  }
`;

export const MapToolboxViewSelectWrapperStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "map-toolbox-view-select-wrapper",
  },
)`
  margin-inline-start: auto;
  font-size: 12px;

  .map-view-selector {
    &:hover {
      background-color: ${rydeColors.focusedOption};
    }

    & .MuiButton-root {
      font-size: 12px;
      min-height: 26px;
      padding-block: 2px;
    }

    & .MuiButtonGroup-firstButton {
      padding-inline: 6px;
      min-width: 104px;
      gap: 5px;
    }

    & .MuiButtonGroup-grouped {
      border-color: ${greyMui._300};
      color: ${rydeColors.black};
      gap: 6px;
    }

    .map-toolbox-group-button.MuiButtonGroup-lastButton.MuiButtonGroup-grouped {
      min-width: 20px;
      padding-inline: 3px;
    }

    .arrow-button {
      padding: 0;
      color: ${greyMui._500};
    }
  }
`;
